function isBasePrimeCost(container: any): boolean {
  return !!(container && container.is_base_prime_cost);
}

function containerCreatedAtMs(container: any): number {
  if (!container || !container.created_at) {
    return 0;
  }
  const ms = new Date(container.created_at).getTime();
  return Number.isFinite(ms) ? ms : 0;
}

/**
 * Among containers marked "Базовая тара", picks the latest by created_at.
 * Ties break by higher id.
 */
export function pickLatestBasePrimeCostContainer(
  containers: any[]
): any | null {
  const bases = (containers || []).filter(isBasePrimeCost);
  if (bases.length === 0) {
    return null;
  }

  return bases.reduce((latest: any, current: any) => {
    if (!latest) {
      return current;
    }
    const latestMs = containerCreatedAtMs(latest);
    const currentMs = containerCreatedAtMs(current);
    if (currentMs > latestMs) {
      return current;
    }
    if (currentMs === latestMs && (current.id || 0) > (latest.id || 0)) {
      return current;
    }
    return latest;
  }, null);
}

function withPrimeCostPrices(node: any, container: any): any {
  return {
    ...node,
    cost: container.cost,
    trade_price: container.trade_price,
    retail_price: container.retail_price
  };
}

/**
 * Copies current-month prime cost fields from the latest base-cost container
 * onto the product row for catalog display.
 */
export function applyBasePrimeCostPrices(product: any): any {
  if (!product) {
    return product;
  }

  const base = pickLatestBasePrimeCostContainer(product.children || []);
  if (!base) {
    return product;
  }

  return withPrimeCostPrices(product, base);
}

/**
 * Copies prices onto a parent product from the latest base-cost container
 * among all descendant (child product) containers.
 */
export function applyBasePrimeCostPricesFromChildren(parent: any): any {
  if (!parent) {
    return parent;
  }

  const containers: any[] = [];
  (parent.children || []).forEach((child: any) => {
    if (child && Array.isArray(child.children)) {
      containers.push(...child.children);
    }
  });

  const base = pickLatestBasePrimeCostContainer(containers);
  if (!base) {
    return parent;
  }

  return withPrimeCostPrices(parent, base);
}
